<template>
  <div class="order-block">
    <div :style="colorStatus"></div>
    <div>
      <div class="mt-2 mb-2">
        <div class="wrap-status d-flex justify-content-start">
          <b-badge pill :style="colorStatus">
            {{status.name || ""}}
          </b-badge>
        </div>
        <div class="wrap-status d-flex justify-content-end">
          <icon
            v-if="order.priority !== 0"
            name="burn"
            v-b-tooltip.hover.right
            title="Срочный заказ!"
            class="important"
            scale="1.375"
          ></icon>
          <icon
            v-if="isCallCenter && order.mustAutoconfirm"
            title="Автоподтверждение"
            name="check-circle"
            class="text-success"
            scale="1.375"
          ></icon>
          <icon
            v-if="order.idOrigin"
            v-b-tooltip.hover.right
            title="Заказ был совершен через сайт"
            name="desktop"
            scale="1.375"
          ></icon>
          <icon
            v-if="order.byMobile"
            v-b-tooltip.hover.right
            title="Заказ был совершен через мобильное приложение"
            name="mobile"
            scale="1.375"
          ></icon>
        </div>
        <div class="d-flex align-items-center">
          <span :style="stylesNumber" class="number">#{{ order.idDay }}</span>
          <icon
            class="ml-2 mr-2"
            :name="notToday ? 'calendar-alt' : planned ? 'stopwatch' : 'clock'"
          ></icon>
          <template v-if="!notToday">
            {{order.forTime
                ? $options.filters.timeByFullTime(order.forTime)
                : $options.filters.time(order.time)}}
          </template>
          <template v-if="notToday">
            {{$options.filters.date(order.forDay)}}
          </template>
          <span
            v-if="isCallCenter"
            class="ml-3 d-flex align-items-center stats-hist"
            :id="'ord-stats-' + order.id"
            @click.stop="showHistory"
          >
              <icon class="mr-2" name="stream"></icon>
              <span>История</span>
          </span>
        </div>
        <div v-if="showPayment">
          <span>{{ order.typePayment.name }}</span>
          <b-badge
            pill
            v-if="order.typePayment.keyword === TYPE_PAYMENT.CARD_ONLINE"
            :variant="order.payment ? 'success' : 'warning'"
          >
              {{ order.payment ? "Оплачено" : "Не оплачено" }}
          </b-badge>
        </div>
        <div class="d-flex justify-content-between">
          <span>
            {{isCourier ? fullAddress(order, "full") : fullAddress(order)}}
          </span
          >
            <b style="white-space: nowrap;">
              {{ order.price }}
              ₽
              {{order.pricePoints > 0 ? "(" + order.pricePoints + " Б)" : ""}}
            </b
          >
        </div>
        <div v-if="isCourier">
          {{
            JSON.parse(order.selectedPosition)
              ? JSON.parse(order.selectedPosition).district
              : ""
          }}
          {{
            JSON.parse(order.selectedPosition)
              ? JSON.parse(order.selectedPosition).settlement
              : ""
          }}
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span v-if="!order.client"
            >{{ order.fio ? order.fio : "Не указано" }}
            <icon class="ml-2 mr-2" name="phone"></icon>
            <a v-if="showRefTel" :href="'tel:' + order.phone">
              {{ order.phone }}
            </a>
            <span v-else>{{ order.phone }}</span>
          </span>
          <span v-if="order.client" class="d-flex align-items-center"
            >{{ order.client.name ? order.client.name : "Не указано" }}
            <icon class="ml-2 mr-2" name="phone" />
            <a v-if="showRefTel" :href="'tel:' + order.client.phone">
              {{ order.client.phone }}
            </a>
            <span v-else>{{ order.client.phone }}</span>
          </span>
          <span v-if="showCourier">
            <icon class="mr-1" name="truck" />
            {{order.courier ? shortNameWorker(order.courier) : "Не задан"}}
          </span
          >
        </div>
        <div v-if="showPersons">
          Кол-во персон:
          {{ order.personNumber ? order.personNumber : "Не указано" }}
        </div>
        <div v-if="showChange && order.change">Сдача с: {{ order.change }}</div>
        <div class="d-flex justify-content-between align-items-center">
          <span class="d-flex align-items-center">
            <icon class="mr-2" name="map-marker-alt" />
            {{ order.point ? order.point.address : "Не указана" }}
          </span>
          <b-badge v-if="order.partner !== null" variant="dark">
            {{partnerOptions[order.partner]}}
          </b-badge>
        </div>
        <span v-if="order.comment" class="comment mt-1">{{
          order.comment ? order.comment : ""
        }}</span>
        <span v-if="order.settlement" class="sellement mt-1">{{
          order.settlement ? "Населенный пункт: " + order.settlement : ""
        }}</span>
        <div class="workshop-stages d-flex justify-content-center">
          <b-badge
            v-for="workshop in workshops"
            :key="workshop.id"
            :id="'workshop-stage-' + workshop.id"
            class="mr-1"
            :variant="
              workshopActive(workshop.keyword, workshop.workshopKeyword)
            "
          >
            <icon
              :name="workshopIcon(workshop.workshopKeyword)"
              scale="1.2"
            ></icon>
            <b-tooltip :target="'workshop-stage-' + workshop.id">
              <table>
                <tr>
                  <td>{{ workshop.status }}</td>
                </tr>
              </table>
            </b-tooltip>
          </b-badge>
        </div>
        <div v-if="order.workerAccept" class="mt-1">
          {{
            order.workerAccept
              ? "Оператор: " + shortNameWorker(order.workerAccept)
              : "Не задан"
          }}
        </div>
        <div class="oder-block__wrapper-btn">
          <div v-if="getCookingTargetTimes(order) && showTimer">
            <TimeCounter
              :end="endTime"
              :displayHint="false"
              :availableSection="{
                days: false,
                hours: true,
                minutes: true,
                seconds: true
              }"
            />
          </div>
          <a
            v-if="showMapBtn"
            :class="`btn btn-primary show-on-map-btn ${mapBtnCls}`"
            target="_blank"
            :href="`https://yandex.ru/maps/?text=${finalAddress}`"
            @click.stop
          >
            <icon class="mr-2" name="map"></icon>
            Показать на карте
          </a>
        </div>
      </div>
      <b-tooltip
        v-if="isCallCenter"
        custom-class="history-order-tooltip-main"
        :target="'ord-stats-' + order.id"
        triggers="click"
      >
        <div
          class="history-order-tooltip"
          @mouseleave="onBlurHistory('ord-stats-' + order.id)"
        >
          <table v-if="order.statuses && order.statuses.nodes.length !== 0">
            <tr v-for="status in order.statuses.nodes" :key="status.id">
              <td>{{ formatStatusTime(status.time) }}</td>
              <td>-</td>
              <td>{{ status.stage.name }}</td>
              <td>-</td>
              <td>{{ shortNameWorker(status.worker) }}</td>
            </tr>
          </table>

          <div v-else>
            Истории статусов по заказу не найдено
          </div>
        </div>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import commonVar from '@/tempVariables/commonVars'
import orderFunc from '@/functionsLib/orderFunc'
import TimeCounter from './common/TimeCounter'
import {STATUS_ORDER, TYPE_PAYMENT} from '@/constants/keywords'
import moment from 'moment';

export default {
  name: 'OrderBlock',
  props: {
    order: {
      type: Object,
      required: true
    },
    showMapBtn: {
      type: Boolean,
      default: false
    },
    mapBtnCls: {
      type: String,
      default: ''
    },
    type: String,
    orderStages: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TimeCounter
  },
  mounted () {
    this.observer.observe(this.$el)
  },
  data: function () {
    return {
      observer: null,
      statusOptions: commonVar.statusOptions,
      partnerOptions: commonVar.partnerOptions,
      TYPE_PAYMENT
    }
  },
  computed: {
    endTime () {
      return new Date(this.getCookingTargetTimes(this.order).targetTime)
    },
    status () {
      if (this.order.idStage && Object.keys(this.orderStages).length) {
        return this.orderStages[this.order.idStage]
      }

      if (this.order.status) {
        return this.order.status
      }

      if (this.order.stageKeyword) {
        return { keyword: this.order.stageKeyword }
      }

      return {}
    },
    workshops () {
      if (this.order.workshop && this.order.workshop.nodes) {
        let workshops = []
        this.order.workshop.nodes.forEach(item => {
          workshops.push({
            id: item.id,
            idOrder: this.order.id,
            name: item.stage.workshop.name,
            keyword: item.stage.keyword,
            workshopKeyword: item.stage.workshop.keyword,
            status: item.stage.name
          })
        })
        return workshops
      }
      return []
    },
    notToday () {
      return this.order.forDay !== this.$moment().format('YYYY-MM-DD')
    },
    planned () {
      return this.order.forTime !== null
    },
    stylesNumber () {
      if (this.notToday) {
        return {
          'text-decoration': 'underline'
        }
      }
      return {}
    },
    isCallCenter () {
      return this.type === 'call-center'
    },
    showPayment () {
      return this.type === 'call-center'
    },
    isCollecting () {
      return this.type === 'collector'
    },
    isCourier () {
      return this.type === 'courier'
    },
    isLogistian () {
      return this.type === 'delivery'
    },
    showCourier () {
      return this.type !== 'courier'
    },
    showPersons () {
      return this.type === 'collector'
    },
    showChange () {
      return this.type === 'courier'
    },
    showTimer () {
      return (this.type === 'delivery' || this.type === 'collector' || this.type === 'courier') && (this.status.keyword !== STATUS_ORDER.END && this.status.keyword !== STATUS_ORDER.PASSED)
    },
    showRefTel () {
      return this.type === 'call-center' || this.type === 'courier'
    },
    showChangeCour () {
      return this.type === 'delivery-list-all'
    },
    colorStatus () {
      let style = {}
      const status = this.status

      if (status.keyword) {
        switch (status.keyword) {
          case STATUS_ORDER.NEW:
            style.background = '#09D7EA'
            break
          case STATUS_ORDER.APPROVED:
            style.background = '#08C456'
            break
          case STATUS_ORDER.END:
            style.background = '#058038'
            break
          case STATUS_ORDER.COLLECTED:
            style.background = '#1B8688'
            break
          case STATUS_ORDER.COOKING:
            style.background = '#7E880B'
            break
          case STATUS_ORDER.COOKED:
            style.background = '#108B25'
            break
          case STATUS_ORDER.PASSED:
            style.background = '#275FF8'
            break
          case STATUS_ORDER.CANCELED:
            style.background = '#6c757d'
            break
          case STATUS_ORDER.SENDED:
            style.background = '#BDE700'
        }
      }
      return style
    },
    finalAddress () {
      const {city, street, house} = this.order
      return [city || 'Тюмень', street, house].filter(_ => _).join(',')
    }
  },
  beforeDestroy () {
    this.observer.disconnect()
  },
  methods: {
    ymapsDetermineDistance (order) {
      this.$emit('ymaps-determine-distance', order)
    },
    workshopIcon (workshopKeyword) {
      switch (workshopKeyword) {
        case 'cold':
          return 'fish'
        case 'hot':
          return 'hamburger'
        case 'pizza':
          return 'pizza-slice'
      }
    },
    onElementObserved (entries) {
      entries.forEach(({ target, isIntersecting }) => {
        this.$emit('shown-hide-order', {
          orderIdDay: this.order.idDay,
          orderId: this.order.id,
          seen: !!isIntersecting
        })
      })
    },
    workshopActive (keyword, workshopKeyword) {
      if (workshopKeyword === 'cold') {
        switch (keyword) {
          case 'knurling':
          case 'knurled':
            return 'warning'
          case 'cutting':
            return 'primary'
          case 'cooked':
            return 'success'
        }
      }
      if (workshopKeyword === 'hot') {
        switch (keyword) {
          case 'cooking':
            return 'warning'
          case 'cooked':
            return 'success'
        }
      }
      if (workshopKeyword === 'pizza') {
        switch (keyword) {
          case 'filling':
            return 'warning'
          case 'baking':
            return 'primary'
          case 'cooked':
            return 'success'
        }
      }
    },
    getCookingTargetTimes (order) {
      if (order.statuses && order.statuses.nodes.length !== 0 && order.point && order.point.targetTimeDeliveryIn) {
        let cookingStage = order.statuses.nodes.find(status => status.stage.keyword === STATUS_ORDER.COOKING)
        if (cookingStage) {
          let cookingTime = this.$moment(cookingStage.time)
          let targetTime = this.$moment(cookingTime).add(parseInt(order.point.targetTimeDeliveryIn), 'minutes')
          let res = {
            cookingTime: cookingTime.format('YYYY-MM-DD HH:mm:ss'),
            targetTime: targetTime.format('YYYY-MM-DD HH:mm:ss')
          }
          return res
        }
      }
      return false
    },
    time () {
      return Date.now()
    },
    showHistory () {
      this.$emit('on-history-show', this.order)
    },
    onBlurHistory (idTooltip) {
      this.$root.$emit('bv::hide::tooltip', idTooltip)
    },
    formatStatusTime (time) {
      return moment(time).format('HH:mm DD.MM.YYYY')
    },
    shortNameWorker: orderFunc.shortNameWorker,
    fullAddress: orderFunc.fullAddress
  },
  created () {
    this.observer = new IntersectionObserver(
      this.onElementObserved,
      {
        root: this.$el,
        threshold: 1.0
      }
    )
  }
}
</script>

<style lang="scss" scoped>
  .workshop-stages {
    margin: .5em 0;
  }
  .order-block {
    display: grid;
    grid-template-columns: 15px 1fr;
    grid-column-gap: 10px;
    padding-right: 1em;
  }
  .number {
      min-width: 50px;
  }
  .wrap-status {
    margin: 0.5em 0;
    svg:not(:last-child) {
      margin-right: 1em;
    }
  }
  .status-order {
      border-radius:0;
      padding: 0.25em 1.4em;
      font-size:0.9rem;
  }
  .sellement {
      display:inline-block;
  }
  .comment {
      background:#c3e3ff;
      padding: 2px 10px;
      border: 1px dashed #000;
      display:inline-block;
  }
  .important {
      -webkit-animation: flickerAnimation 1s infinite;
      -moz-animation: flickerAnimation 1s infinite;
      -o-animation: flickerAnimation 1s infinite;
      animation: flickerAnimation 1s infinite;
      color: coral;
      border-radius: 0;
  }
  @keyframes flickerAnimation {
    0%   { opacity:1; transform: scale(1.2);}
    50%  { opacity:0; transform: scale(1.0);}
    100% { opacity:1; transform: scale(1.2);}
  }
  @-o-keyframes flickerAnimation {
    0%   { opacity:1; transform: scale(1.2);}
    50%  { opacity:0; transform: scale(1.0);}
    100% { opacity:1; transform: scale(1.2);}
  }
  @-moz-keyframes flickerAnimation {
    0%   { opacity:1; transform: scale(1.2);}
    50%  { opacity:0; transform: scale(1.0);}
    100% { opacity:1; transform: scale(1.2);}
  }
  @-webkit-keyframes flickerAnimation {
    0%   { opacity:1; transform: scale(1.2);}
    50%  { opacity:0; transform: scale(1.0);}
    100% { opacity:1; transform: scale(1.2);}
  }
  .stats-hist {
    border: 1px solid black;
    padding: 0 3px;
  }
  .history-order-tooltip {
    width: 100%;
  }
</style>
<style>
  .history-order-tooltip-main tr {
    border-bottom: 1px solid black;
  }
  .history-order-tooltip-main .tooltip-inner {
    max-width: 300px;
    background: #ffffff;
    color: #212529;
    border: 1px solid #212529;
    border-radius: 10px;
  }
  .order.busy-order {
    background: yellow;
  }
  .order.opened-by-me-order {
    background: #F8FFE7;
  }
  .text-break {
    white-space: normal;
  }

  .oder-block__wrapper-btn
  {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .no-select {
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderBlock.vue